export class Item {
    private _id:number;
    private _price:number;
    private _name:string;
    private _quantity:number;
    private _assessment_uid:string;
    private _subItems?:Item[];

    constructor() {
        this.price = 0;
        this.name = "";
        this.quantity = 0;
        this.subItems = [];
    }

    get id() {
        return this._id;
    }
    set id(v:number) {
        this._id = v;
    }

    get totalPrice() {
        let totalPrice = +(this.price * this.quantity).toFixed(2);
        return totalPrice;
    }

    get price() {
        return this._price;
    }
    set price(v:number) {
        if (v < 0) {
            throw new Error("Price cannot be set to less than 0");
        }
        this._price = v;
    }

    get name() {
        return this._name;
    }
    set name(v:string) {
        this._name = v;
    }

    get quantity() {
        return this._quantity;
    }

    set quantity(v:number) {
        let vChecked = +v;
        if (isNaN(v)) {
            throw new Error("Quantity must be a valid number");
        }

        if (v < 0) {
            throw new Error("Quantity cannot be set to less than 0");
        }
        this._quantity = vChecked;
    }

    get subItems() {
        return this._subItems;
    }

    set subItems(v:Item[]) {
        if (v == null) {
            throw new Error("subItems cannot be null");
        }
        this._subItems = v;
    }


	public get assessment_uid(): string {
		return this._assessment_uid;
	}

	public set assessment_uid(value: string) {
		this._assessment_uid = value;
	}
    
}


// WEBPACK FOOTER //
// ./src/app/admin/models/item.ts